import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
})
export default class ViewForm extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Object }) item!: contacts.ContactItem

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    async writeMail() {
        if (this.item.email) {
            this.$router.push({
                path: '/mail/write',
                query: { id: '', type: 'draft', uid: this.item.email },
            });
        } else {
            await(window as any).alertAsync(this.$t('M_Contact_NoEmail').toString());
        }
    }
}
